var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ReportAnalyticsEnum, ReportSecondaryAnalyticsEnum, } from '../types';
function template(strings) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var dict = values[values.length - 1] || {};
        var result = [strings[0]];
        keys.forEach(function (key, i) {
            var value = Number.isInteger(key) ? values[key] : dict[key];
            if (!value && result[i].at(-1) === ' ') {
                result[i] = result[i].slice(0, -1);
            }
            result.push(value, strings[i + 1]);
        });
        return result.join('');
    };
}
export var defaultAssessmentReportConfig = {
    movementName: 'default',
    analytics: [
        {
            analytic: ReportAnalyticsEnum.GRFMax,
            title: 'Ground Reaction Force',
            primaryMetric0Label: 'L Max',
            primaryMetric1Label: 'R Max',
            secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
            statusThresholds: [10, 20, 100],
            statusText: ['Balanced', template(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
        },
        {
            analytic: ReportAnalyticsEnum.KneeLoadMax,
            title: 'Knee Load',
            primaryMetric0Label: 'L Max',
            primaryMetric1Label: 'R Max',
            secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercentIfPositive,
            statusThresholds: [10, 20, 100],
            statusText: ['Balanced', template(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_4 || (templateObject_4 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
        },
        {
            analytic: ReportAnalyticsEnum.HipFlexionMax,
            title: 'Hip Flexion',
            primaryMetric0Label: 'L Max',
            primaryMetric1Label: 'R Max',
            secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
            statusThresholds: [10, 20, 100],
            statusText: ['Balanced', template(templateObject_5 || (templateObject_5 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_6 || (templateObject_6 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
        },
        {
            analytic: ReportAnalyticsEnum.KneeFlexionMax,
            title: 'Knee Flexion',
            primaryMetric0Label: 'L Max',
            primaryMetric1Label: 'R Max',
            secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
            statusThresholds: [10, 20, 100],
            statusText: ['Balanced', template(templateObject_7 || (templateObject_7 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_8 || (templateObject_8 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
        },
    ],
};
export var lowerBodyAssessmentReportConfig = [
    {
        movementName: 'squat',
        analytics: [
            {
                analytic: ReportAnalyticsEnum.GRFMax,
                title: 'Ground Reaction Force',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_9 || (templateObject_9 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_10 || (templateObject_10 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.HipLoadMax,
                title: 'Hip Load',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercentIfPositive,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_11 || (templateObject_11 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_12 || (templateObject_12 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.KneeLoadMax,
                title: 'Knee Load',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercentIfPositive,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_13 || (templateObject_13 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_14 || (templateObject_14 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.HipFlexionMax,
                title: 'Hip Flexion',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_15 || (templateObject_15 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_16 || (templateObject_16 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.KneeFlexionMax,
                title: 'Knee Flexion',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_17 || (templateObject_17 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_18 || (templateObject_18 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
        ],
    },
    {
        movementName: 'walking gait',
        analytics: [
            {
                analytic: ReportAnalyticsEnum.GRFMax,
                title: 'Ground Reaction Force',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_19 || (templateObject_19 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_20 || (templateObject_20 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.HipExtensionMax,
                title: 'Hip Extension',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_21 || (templateObject_21 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_22 || (templateObject_22 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
        ],
    },
    {
        movementName: 'single leg squat',
        analytics: [
            {
                analytic: ReportAnalyticsEnum.HipLoadMax_Monopedal,
                title: 'Hip Load',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercentIfPositive,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_23 || (templateObject_23 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_24 || (templateObject_24 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.KneeLoadMax_Monopedal,
                title: 'Knee Load',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercentIfPositive,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_25 || (templateObject_25 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_26 || (templateObject_26 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.HipFlexionMax,
                title: 'Hip Flexion',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_27 || (templateObject_27 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_28 || (templateObject_28 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.KneeFlexionMax,
                title: 'Knee Flexion',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_29 || (templateObject_29 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_30 || (templateObject_30 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
        ],
    },
    {
        movementName: 'single leg romanian deadlift',
        analytics: [
            {
                analytic: ReportAnalyticsEnum.HipLoadMax_Monopedal,
                title: 'Hip Load',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercentIfPositive,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_31 || (templateObject_31 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_32 || (templateObject_32 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.KneeLoadMax_Monopedal,
                title: 'Knee Load',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercentIfPositive,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_33 || (templateObject_33 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_34 || (templateObject_34 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.HipFlexionMax,
                title: 'Hip Flexion',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_35 || (templateObject_35 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_36 || (templateObject_36 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
            {
                analytic: ReportAnalyticsEnum.KneeFlexionMax,
                title: 'Knee Flexion',
                primaryMetric0Label: 'L Max',
                primaryMetric1Label: 'R Max',
                secondaryAnalytic: ReportSecondaryAnalyticsEnum.DeltaPercent,
                statusThresholds: [10, 20, 100],
                statusText: ['Balanced', template(templateObject_37 || (templateObject_37 = __makeTemplateObject(["Minor ", " Bias"], ["Minor ", " Bias"])), 'leftRight'), template(templateObject_38 || (templateObject_38 = __makeTemplateObject(["Major ", " Bias"], ["Major ", " Bias"])), 'leftRight')],
            },
        ],
    },
];
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38;
//# sourceMappingURL=assessment-report-config.js.map